// MUST stay the first import — sets Zod jitless before any module-scope schema
// is constructed (hoisted imports run before this file's body). See the file.
import "./lib/zod-jitless";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { initRuntimeReporter } from "@plerity/runtime-reporter";

// Phase 7: production runtime-error reporter — captures window.error +
// unhandledrejection and POSTs to /api/observability/errors.
// Disabled in dev (the test-time helper handles E2E specs).
initRuntimeReporter({
  app: "email",
  disabled: import.meta.env.MODE !== "production",
  buildSha: import.meta.env.VITE_BUILD_SHA ?? "dev",
});

// Register the X-Tenant-Id interceptor on the shared dashboard apiClient so
// super-admin org switching affects shared-hook queries (not just local-client
// mutations). The registration + its rationale live with the selectedOrgId
// owner in ./lib/admin; invoked here once, before the first query fires.
import { registerSharedApiClientOrgInterceptor } from "./lib/admin";

registerSharedApiClientOrgInterceptor();

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found in DOM");
ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
